import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { InpectionPhase } from "../../inspection.d";
import type { IAnswer, IQuestion } from "@/types/types";
import { useState, type FC } from "react";
import { Icon } from "@/components/icons/Icon";
import { Pill } from "@/components/pill/Pill";
import BloquedAnswerMobile from "../answer/BloquedAnswerMobile";
import AnswerMobile from "./answers/AnswerMobile";

interface PhasesResumeProps {
  phases: InpectionPhase[];
  currentPhase: number;
  question: IQuestion;
  phaseLabel: string;
  restOfAnswers: { [phaseId: number]: IAnswer[] };
  index: number;
}

const PhasesResume: FC<PhasesResumeProps> = ({
  phases,
  currentPhase,
  question,
  phaseLabel,
  restOfAnswers,
  index,
}) => {
  const translate = useTranslate();
  const [view, setView] = useState<"collapsed" | "expanded">("collapsed");

  const handleOnClick = () => {
    setView((prev) => (prev === "collapsed" ? "expanded" : "collapsed"));
  };

  return (
    <div className="">
      {view === "expanded" && (
        <div className="flex flex-col divide-y divide-ib-gray-light-1">
          {phases.map((phase) => {
            if (currentPhase === phase.phaseId) {
              return (
                <div
                  key={"phase-" + question.questionId + "-" + phase.phaseName}
                  className="flex gap-2 items-center justify-between p-2 bg-ib-gray-lightest-2"
                >
                  <div className="flex gap-2 items-center">
                    <Icon name="lockOpen" className="size-4" />
                    <h4 className="font-ib-bold">{translate(phaseLabel)}</h4>
                  </div>
                  <div>
                    <Pill
                      icon="refresh"
                      label={translate("inProgress")}
                      className="bg-ib-blue"
                    />
                  </div>
                </div>
              );
            }

            const answer =
              (restOfAnswers[phase.phaseId] &&
                restOfAnswers[phase.phaseId]?.find(
                  (ans) => ans.questionId === question.questionId,
                )) ||
              null;
            if (answer) {
              return (
                <AnswerMobile
                  item={answer}
                  idx={index}
                  phaseLabel={phase.phaseName}
                />
              );
            }
            return (
              <BloquedAnswerMobile
                phase={phase}
                key={"phase-" + question.questionId + "-" + phase.phaseName}
              />
            );
          })}
        </div>
      )}
      <button
        type="button"
        onClick={handleOnClick}
        className="w-full flex justify-end items-center text-ib-red-main p-2 "
      >
        {view === "collapsed" ? (
          <>
            <p>{translate("phaseAction")}</p>
            <Icon name="chevronDown" />
          </>
        ) : (
          <>
            <p>{translate("close")}</p>
            <Icon name="chevronUp" />
          </>
        )}
      </button>
    </div>
  );
};

export default PhasesResume;
